import UtilityPageLayout from '../../component/layout/UtilityPageLayout';
import styles from '../../component/placeholder.module.scss';

export const ServiceRequestDashboardPage = () => {
	return (
		<UtilityPageLayout title="Service Request Dashboard">
			<div className={styles.placeholderContainer}>
				<h2 className={styles.title}>Service Request Dashboard</h2>
				<p className={styles.description}>
					Monitor and analyze service request metrics, track performance indicators,
					and view real-time statistics for all service operations.
				</p>
				<div className={styles.comingSoon}>Coming Soon</div>
			</div>
		</UtilityPageLayout>
	);
};
